import type { FC } from 'react';
import { Alert, Empty } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useChargesColumns } from './hooks/useChargesColumns';
import { useChargesTable } from './hooks/useChargesTable';
import { SessionFilters } from './components/SessionFilters';
import { EvimoTable } from '~/app/components/common/EvimoTable/EvimoTable';
import { EvimoListPanel } from '~/app/components/common/EvimoListPanel/EvimoListPanel';

export const ChargesTable: FC = () => {
  const { t } = useTranslation('sessions');
  const navigate = useNavigate();
  const columns = useChargesColumns();
  const table = useChargesTable();

  return (
    <EvimoListPanel>
      <SessionFilters
        range={table.range}
        onRangeChange={table.setRange}
        siteName={table.siteName}
        sites={table.sites}
        onSiteChange={table.setSiteName}
        onSiteSearch={table.onSiteSearch}
        chargerName={table.chargerName}
        chargers={table.chargers}
        onChargerChange={table.setChargerName}
        onChargerSearch={table.onChargerSearch}
        connectorName={table.connectorName}
        connectors={table.connectors}
        onConnectorChange={table.setConnectorName}
        onConnectorSearch={table.onConnectorSearch}
        sessionStatus={table.sessionStatus}
        onSessionStatusChange={table.setSessionStatus}
        anomalyQualification={table.anomalyQualification}
        onAnomalyQualificationChange={table.setAnomalyQualification}
        search={table.search}
        onSearchChange={table.setSearch}
      />
      {table.isError ? (
        <Alert
          type="error"
          showIcon
          message={t('loadError')}
          style={{ margin: '12px 16px' }}
        />
      ) : null}
      <EvimoTable
        rowKey="id"
        columns={columns}
        dataSource={table.charges}
        loading={table.isLoading}
        pagination={{
          current: table.page,
          pageSize: table.pageSize,
          total: table.total,
          onChange: (page, pageSize) => {
            if (pageSize !== table.pageSize) {
              table.setPageSize(pageSize);
              return;
            }
            table.setPage(page);
          },
        }}
        scroll={{ x: 'max-content' }}
        locale={{ emptyText: <Empty description={t('emptyCharges')} /> }}
        onRow={(row) => ({
          onClick: () => navigate(`/sessions/${row.identifier}`),
          style: { cursor: 'pointer' },
        })}
      />
    </EvimoListPanel>
  );
};
